<template>
    <div>
        <img src="/images/moj-predmet/uporabniki-priporocajo/play.png" class="play-uporabniki-priporocajo" @click="openIframe()">
        <div v-if="iframeOpen" class="iframe-popup">
            <div class="close-button" @click="closeIframe()"></div>
            <div class="centered">
                <div v-if="!loaded" class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>
                <iframe :src="'https://s3-eu-west-1.amazonaws.com/rokus-video-transcode/player/index.html?video=moj_predmet_irokus/' + videoTitle + '/stream'" ref="iframe" v-on:load="iframeLoaded()"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                iframeOpen: false,
                loaded: false
            }
        },
        props: ['videoTitle'],
        created() {
            window.addEventListener('resize', _.debounce(this.setHeight, 150));
        },
        mounted() {
            
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setHeight);
        },
        methods: {
            openIframe() {
                this.iframeOpen = true;
            },
            closeIframe() {
                this.iframeOpen = false;
            },
            iframeLoaded() {
                this.loaded = true;

                this.$nextTick(() => {
                    this.setHeight();
                });
            },
            setHeight() {
                if (!this.iframeOpen) return;

                let width = this.$refs.iframe.offsetWidth;

                // 16x9 aspect ratio
                if (width > 500) {
                    this.$refs.iframe.style.height = width * 9 / 16 + 'px';
                }
                else {
                    this.$refs.iframe.style.height = (width * 9 / 16) + 200 + 'px';
                }
            }
        }
    }
</script>

<style type="text/css" lang="scss">
    
.iframe-popup {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    background-clip: padding-box;
    text-align: center;

    .close-button {
        position: absolute;
        right: 40px;
        top: 40px;
        width: 40px;
        height: 40px;
        cursor: pointer;
        border: 2px solid #fff;
        border-radius: 50%;
        background: rgba(0,0,0,0.5);

        &:hover {
            opacity: 0.7;
        }

        &:before, &:after {
            position: absolute;
            left: 16px;
            top: 5px;
            content: ' ';
            height: 25px;
            width: 4px;
            background-color: #fff;
        }

        &:before {
            transform: rotate(45deg);
        }

        &:after {
            transform: rotate(-45deg);
        }
    }

    

    .centered {
        margin: 0 auto;
        max-width: 1000px;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;

        iframe {
            width: 100%;
            border: none;

            &:focus {
                outline: none;
            }
        }    
    }
    
}

.spinner {
    width: 70px;
    position: absolute;
}

.spinner > div {
    width: 18px;
    height: 18px;
    background-color: #fff;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
    0%, 80%, 100% { 
        -webkit-transform: scale(0);
        transform: scale(0);
    } 40% { 
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }
}

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/MpVideo.vue